import React, { useState, useEffect } from "react";
import "./Articles.css";
import Header from "../../Hoc/Header";
import Footer from "../../Hoc/Footer";
import axios from "axios";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { Link } from "react-router-dom";
import styles from "./Article.module.scss";

function Articles() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`https://arianaapp.arianaapply.com/api/V1/get-news`)
      .then((res) => {
        console.log(res);
        setPosts(res.data || []);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  return (
    <>
      <div className={styles.article}>
        <Header title="مقالات" />

        <div className={styles.articleBody}>
          {loading ? (
            <div className="spinner">
              <Loader
                type="TailSpin"
                color="rgb(236, 177, 28)"
                height={80}
                width={80}
              />
            </div>
          ) : posts.length > 0 ? (
            [...posts].reverse().map((post) => (
              <Link
                to={`/articles-single/${post._id}`}
                key={post._id}
                className={styles.articleLink}
              >
                <div className={styles.articleText}>
                  <h5>{post.title}</h5>
                  <p className="one-line">{post.content}</p>
                </div>

                <div className={styles.articleImg}>
                  <img src={post.img?.url} alt={post.title || "article"} />
                </div>
              </Link>
            ))
          ) : (
            <p style={{ textAlign: "center", padding: "20px" }}>
              مقاله‌ای یافت نشد
            </p>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Articles;